<template>
  <TransitionRoot appear :show="store.state.openYoutubePopup" as="template">
    <Dialog as="div" @close="store.dispatch('closeYoutubePopup')" class="relative z-20">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-[#344054] bg-opacity-60 backdrop-blur-sm" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-3 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-md transform overflow-hidden rounded-lg bg-white xs:px-2 lg:px-2 pb-3 pt-9 text-left align-middle transition-all relative"
            >


              <span class="absolute right-2 top-2">
                <Button icon-name="close" icon="only-icon" @click="store.dispatch('closeYoutubePopup')" type="transparent" radius="pill" size="middle" tabindex="-1" />
              </span>
              <div class="p-1 flex justify-center">
              <iframe v-if='id == 1' width="414" height="737" src="https://www.youtube.com/embed/QVRpd8ltASk" title="Gennadiy Grigoryan | MedicalLicensing.com Review" frameborder="0" allow="" allowfullscreen></iframe>
              <iframe v-if='id == 2' width="414" height="737" src="https://www.youtube.com/embed/ZvR9mKHDYvk" title="Samir Wassef | MedicalLicensing.com Review" frameborder="0" allow="" allowfullscreen></iframe>
              <iframe v-if='id == 3' width="414" height="737" src="https://www.youtube.com/embed/D9ApvnsJoLM" title="Chet Tharpe | MedicalLicensing.com Review" frameborder="0" allow="" allowfullscreen></iframe>
              <iframe v-if='id == 4' width="414" height="737" src="https://www.youtube.com/embed/3E3lnGVJDbg" title="Karim Trad | MedicalLicensing.com Review" frameborder="0" allow="" allowfullscreen ></iframe>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/vue'

const store = useStore()

  const props = defineProps({
    id: {
      type: Number,
      default: 0,
    }
  })

</script>
